module.exports = __webpack_public_path__ + "media/images/attention_icon-b7a792bd9b25e59e005bf8febda3005a.png";